import { useStylesPatientAppRedesign } from 'hooks';

export default function useHeaderBrandingConfiguration(isDesktop?: boolean) {
  // Adjust the header based on the branding redesign configuration
  const stylesPatientAppRedesign = useStylesPatientAppRedesign();

  const includeLanguageSelector =
    !stylesPatientAppRedesign || !!stylesPatientAppRedesign.styles?.theme?.includeLanguageSelector;

  // Include links configured by the branding
  const links = stylesPatientAppRedesign?.styles?.theme?.includeMenuWithLinks?.links || [];
  const includeLinks = !!links.length && !!stylesPatientAppRedesign?.styles?.theme?.includeMenuWithLinks?.enabled;
  const includeBarWithLinks = includeLinks && isDesktop;
  const includeButtonWithLinks = includeLinks && !isDesktop;

  return { includeLanguageSelector, includeBarWithLinks, includeButtonWithLinks, links };
}
